//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputGroup from '@/components/form/InputGroup'
import AxiosErrorHandler from '@/mixins/AxiosErrorHandler'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'AgentPayoutAddressForm',
  components: { InputGroup },
  mixins: [AxiosErrorHandler],
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      saving: false,
      form: {
        address: null
      }
    }
  },
  validations: {
    form: {
      address: {
        required
      }
    }
  },
  mounted () {
    this.form.address = this.task.agentCryptoPayoutAddress
  },
  methods: {
    async saveAddress () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        try {
          this.saving = true
          await this.$store.dispatch('tasks/updateAgentsCryptoPayoutAddress', {
            address: this.form.address,
            taskId: this.task.id
          })
          await this.$store.dispatch('ui/showNotification', {
            type: 'success',
            text: this.$t('agent.tasks.payoutAddressModalSuccess')
          })
          this.saving = false
          this.$emit('saved')
        } catch (err) {
          this.saving = false
          await this.handleError(err)
        }
      }
    }
  }
}
